import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../commonFunctions";
  
  const rp031 = {
    label: "Scroll In Reports",
    starting: true,
    url: "rp031",
    pageLabel: "Scroll In Reports",
    pageType: "history",
    form: [
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Parent Branch",
        label: "Parent Branch",
        name: "parentbranch",
        description: "Enter Parent Branch"
      },
      {
        inputType: "autocomplete",
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        ajaxLoad: true,
        ajaxOptions: {
          value: "code",
          label: "descn",
          query: {
            dialect: "mysql",
            query: "getBranchName"
          }
        },
        options: [],
        //prepend:"Br.Name";
        placeHolder: "Parent Branch ",
        name: "parentbranch",
        description: "Enter Parent Branch Code"
      },
      {
        inputType: "showdata",
        data: "Main Branch",
        textcolor: "black",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        }
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Print Particulars",
        name: "printparticulars",
        description: ""
      },
     
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "General Ledger",
        label: "General Ledger",
        name: "generalledger",
        description: "Enter General Ledger"
      },
      {
        inputType: "autocomplete",
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        ajaxLoad: true,
        ajaxOptions: {
          value: "code",
          label: "descn",
          query: {
            dialect: "mysql",
            query: "getBranchName"
          }
        },
        options: [],
        //prepend:"Br.Name";
        placeHolder: "General Ledger",
        name: "generalledger",
        description: "Enter General Ledger"
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-5",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Print Voucher Type",
        name: "printvouchertype",
        description: ""
      },
      
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "From-To Date",
        name: "",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "fromdate",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "todate",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Print Batch No",
        name: "printbatchno",
        description: ""
      },
      
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Transaction type",
        name: "",
        description: ""
      },
      {
        inputType: "select",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        options:[
            {
                label:"All",
                value:"All"
            },
            {
                label:"Cash",
                value:"Cash"
            },
            {
                label:"Transfer",
                value:"Transfer"
            }
        ],
        placeHolder: "",
        label: "",
        name: "Transactiontype",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Credit/Debit By",
        name: "",
        description: ""
      },
      {
        inputType: "select",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        options:[
            {
                label:"Credit",
                value:"Credit"
            },
            {
                label:"Dedit",
                value:"Dedit"
            },
            {
                label:"Both",
                value:"Both"
            }
        ]
        ,
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Voucher Type",
        name: "",
        description: ""
      },
      {
        inputType: "select",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        options:[
            {
                label:"Cash Receipt",
                value:"Cash Receipt"
            },
            {
                label:"Cash Payment",
                value:"Cash Payment"
            },
            {
                label:"Transfer",
                value:"Transfer"
            },
            {
                label:"Clearing Credit",
                value:"Clearing Credit"
            },
            {
                label:"Clearing Debit",
                value:"Clearing Debit"
            },
            {
                label:"NEFT",
                value:"NEFT"
            },
            {
                label:"RTGS",
                value:"RTGS"
            },
            {
                label:"Standing",
                value:"Standing"
            },
            {
                label:"Closure",
                value:"Closure"
            }
        ]
        ,
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      
      
    ]
  };
  
  export default rp031;
  